var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "photo-lower-bar-button-group" }, [
    _c(
      "div",
      {
        staticClass: "photo-lower-bar-button-custom",
        on: {
          click: function($event) {
            return _vm.rotateRight()
          }
        }
      },
      [_c("SVGPhotoRotateLeft45", { staticClass: "lb-svg-rotate" })],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "photo-lower-bar-button-custom no-left-padding",
        on: {
          click: function($event) {
            return _vm.rotateLeft()
          }
        }
      },
      [_c("SVGPhotoRotateRight45", { staticClass: "lb-svg-rotate" })],
      1
    ),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "photo-lower-bar-button",
        on: {
          click: function($event) {
            return _vm.switchShades()
          }
        }
      },
      [
        _c("SVGShadeOff", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.shadowStatus,
              expression: "!shadowStatus"
            }
          ],
          staticClass: "lb-svg"
        }),
        _vm._v(" "),
        _c("SVGShadeOn", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.shadowStatus,
              expression: "shadowStatus"
            }
          ],
          staticClass: "lb-svg"
        }),
        _vm._v(" "),
        _c(
          "span",
          { staticClass: "photo-lower-bar-button-text extra-left-padding" },
          [_vm._v(_vm._s(_vm.shadeButtonText))]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "photo-lower-bar-button",
        on: {
          click: function($event) {
            return _vm.switchLightCorrection()
          }
        }
      },
      [
        _c("SVGSunBlack", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.lightCorrectionStatus,
              expression: "lightCorrectionStatus"
            }
          ],
          staticClass: "lb-svg"
        }),
        _vm._v(" "),
        _c("SVGSunShine", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.lightCorrectionStatus,
              expression: "!lightCorrectionStatus"
            }
          ],
          staticClass: "lb-svg"
        }),
        _vm._v(" "),
        _c(
          "span",
          { staticClass: "photo-lower-bar-button-text extra-left-padding" },
          [_vm._v(_vm._s(_vm.lightCorrectionButtonText))]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "photo-lower-bar-button no-left-padding" },
      [
        _c(
          "div",
          {
            staticClass: "photo-lower-bar-button-text",
            staticStyle: { cursor: "default", color: "#939393" }
          },
          [_vm._v("Повернуть")]
        )
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }